module.exports = __webpack_public_path__ + "media/fr_fr_s4_Sophie.1373c7a8.oga";